import React from 'react';
import {BrowserRouter, Route, Switch} from 'react-router-dom';

import './scss/style.scss';
import Login from './views/pages/login/Login';
import Layout from './containers/Layout';
import Page404 from './views/pages/page404/Page404';
import store from './store';
import VerifyCode from "./views/pages/login/VerifyCode";

const App = () => {
  console.log(
    `"You are running this application in ${process.env.REACT_APP_ENV} env and pointed to ${process.env.REACT_APP_LEASE_LOOKUP_URL}`);

  const userSessionFromStore = store.getState()?.userSession;

  if (userSessionFromStore?.token) {
    return (
        <BrowserRouter>
          <Switch>
            <Route path="/" name="Home" render={props => <Layout/>}/>
          </Switch>
        </BrowserRouter>)
  } else {
    console.log("No userSession in App");
    return (
        <BrowserRouter>
          <Switch>
            <Route exact path="/login" name="Login Page">
              <Login/>
            </Route>
            <Route exact path="/verifyCode" name="Verify Code Page">
              <VerifyCode/>
            </Route>
            <Route exact path="/404" name="Page 404"
                   render={props => <Page404 {...props}/>}/>
            <Route path="/" name="Home" render={props => <Layout/>}/>
          </Switch>
        </BrowserRouter>)
  }
}

export default App;
